/** Client-only preferences until Core exposes notification / privacy / feed prefs. */

const STORAGE_KEY = "meetoor_settings_prefs_v1";

/** @type {Record<string, unknown>} */
const DEFAULT_PREFS = {
    // Privacy — UI placeholders (see TODO in Privacy section; visibility fields use Core mutation).
    socialProfileVisibility: "public",
    whoCanMessage: "everyone",
    whoCanComment: "everyone",
    whoCanTag: "friends",
    showOnlineStatus: true,
    allowFollowers: true,
    storyVisibility: "followers",

    // Notifications (non-sound).
    notifyPush: true,
    notifyEmail: true,
    notifyMessages: true,
    notifyComments: true,
    notifyMentions: true,
    notifyTeam: true,
    notifyFriendRequests: true,
    notifyStories: true,

    // Appearance (themePreference augments Redux `isDark` when not "system").
    themePreference: "system",
    compactFeed: false,
    /** Text size percent, one of `TEXT_SIZES` (textSize.js). */
    fontScale: 100,

    // Chat & messaging
    readReceipts: true,
    typingIndicators: true,
    autoDownloadMedia: true,

    // Feed
    feedAutoplayVideos: true,
    feedSensitiveContent: false,
    feedRecommendedPosts: true,
    feedRecommendedUsers: true,
    feedTrendingTopics: true,
    feedHideViewedPosts: false,
};

/**
 * @returns {Record<string, unknown>}
 */
export function loadSettingsPrefs() {
    try {
        const raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return { ...DEFAULT_PREFS };
        const parsed = JSON.parse(raw);
        return { ...DEFAULT_PREFS, ...parsed };
    } catch {
        return { ...DEFAULT_PREFS };
    }
}

/**
 * @param {Record<string, unknown>} prefs
 */
export function saveSettingsPrefs(prefs) {
    try {
        window.localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
    } catch {
        /* noop */
    }
}

/**
 * @param {(prev: Record<string, unknown>) => Record<string, unknown>} updater
 */
export function patchSettingsPrefs(updater) {
    const next = updater(loadSettingsPrefs());
    saveSettingsPrefs(next);
    return next;
}
